export const loadedSiteData = ({ pages, blogs, meta }) => {
  return {
    payload: { pages, blogs, meta },
    type: 'LOADED_SITE_DATA'
  }
};

export const fatalError = (message) => {
  return {
    payload: { message },
    type: 'FATAL_ERROR'
  }
};

export const setSiteContent = (pages) => {
  return {
    payload: { pages },
    type: 'SET_SITE_PAGEST'
  };
};

export const setSiteMeta = (meta) => {
  return {
    payload: { meta },
    type: 'SET_SITE_META'
  }
};

export const setSiteBlogs = (blogs) => {
  return {
    payload: { blogs },
    type: 'SET_SITE_BLOGS'
  };
};



// WEBPACK FOOTER //
// ./client/Site/State/ActionCreators.js